import angular from "angular";
import { vsModuleName as configModuleName } from "./configs/module";
import { routeConfig } from "./routes";
import {
  mealLogEntryDetailComponentOptions,
  vsComponentName as mealLogEntryDetailComponentName,
} from "./components/entryDetail/component";
import {
  mealLogEntryListComponentOptions,
  vsComponentName as mealLogEntryListComponentName,
} from "./components/entryList/component";

export const vsModuleName = "SlotTrak.Machines.MealLog";

angular
  .module(vsModuleName, [configModuleName])
  .config(routeConfig)
  .component(
    mealLogEntryDetailComponentName,
    mealLogEntryDetailComponentOptions
  )
  .component(mealLogEntryListComponentName, mealLogEntryListComponentOptions);
